module.exports = __webpack_public_path__ + "img/05.e70e0c64.jpg";